exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".address{position:relative}.address,.address .select-box{width:100%;box-sizing:border-box}.address .select-box{padding:4px 10px}.address .select-box-city{width:100%;padding:6px 12px;border-radius:4px;border:1px solid #e4e5e7;box-sizing:border-box}.address .select-box-city .isSelectColor{color:#bbbfc4}.address .select-box-address{width:100%;margin-top:16px;padding:6px 7px;font-size:14px;border-radius:4px;box-sizing:border-box}.address .select-box .l-textarea::-webkit-input-placeholder{color:#ccc!important}", ""]);

// exports
